
import {Vue, Component} from 'vue-property-decorator';
import {Call, Sync} from 'vuex-pathify';
@Component({
    components: {
    },
})
export default class CancelBookingProcessMixin extends Vue {
    @Sync('booking/services') private services!: any[];
    @Sync('ui/appBarVisible') private showNavbar!: boolean;
    @Call('booking/setStep') private setBookingStep!: (step: number) => number;
    @Call('packages/setStep') public setPackagesStep!: (step: number) => number;
    @Call('booking/setFormattedAddress') private setFormattedAddress!: (formattedAddress: string | null) => string;
    @Call('booking/setLatitude') private setLatitude!: (latitude: number | null) => number;
    @Call('booking/setLongitude') private setLongitude!: (longitude: number | null) => number;
    @Call('booking/setCategory') private setCategory!: (rate: any) => any;
    @Sync('booking/serviceType') public serviceType!: any;
    @Sync('booking/tier') public tier!: any;
    @Call('booking/setEditingService') private setEditingService!: (editingService: number) => number;
    @Call('booking/setServices') private setServices!: (service: any[]) => any;
    @Call('booking/setDates') private setDates!: (dates: string[]) => string[];
    @Call('booking/setTimes') private setTimes!: (time: string[]) => string[];
    @Call('booking/setVendors') private setVendors!: (vendors: any[]) => any[];
    @Call('booking/setDurations') public setDurations!: (guests: number[]) => number[];
    @Call('booking/setGuests') public setGuests!: (guests: number[]) => number[];
    @Call('booking/setDiscount') public setDiscount!: (discount: number) => number;
    @Call('booking/setDiscountIsFlat') public setDiscountIsFlat!: (discountIsFlat: boolean) => boolean;
    @Call('booking/setDiscountDescription') public setDiscountDescription!: (discountDescription: string) => string;
    @Call('booking/setDiscountForOrder') public setDiscountForOrder!: (discountForOrder: boolean) => boolean;
    @Sync('booking/discountConditional') public discountConditional!: string;
    private cancelBooking() {
        setTimeout(() => {
            this.setBookingStep(1);
            this.setPackagesStep(1);
            this.setFormattedAddress(null);
            this.setLatitude(null);
            this.setLongitude(null);
            this.setCategory(null);
            this.setServices([]);
            this.tier = null;
            this.setEditingService(0);
            this.serviceType = null;
            this.setTimes([]);
            this.setDates([]);
            this.setVendors([]);
            this.setDurations([]);
            this.setGuests([]);
            this.setDiscount(0);
            this.setDiscountIsFlat(true);
            this.setDiscountDescription('');
            this.discountConditional = '';
            this.setDiscountForOrder(true);
        }, 500);
    }
}
